<template>
  <div class="card password-validations">
    <div class="card-body">
      <div class="card-title">
        Uw wachtwoord:
      </div>
      <ul class="pass_list">
        <li v-bind:class="{ is_valid: passwordValidation.contains_eight_characters, pass_check: true}">
          Minimaal 8 tekens
        </li>
        <li v-bind:class="{ is_valid: passwordValidation.contains_number, pass_check: true }">
          Bevat minimaal 1 cijfer
        </li>
        <li v-bind:class="{ is_valid: passwordValidation.contains_uppercase, pass_check: true }">
          Bevat minimaal 1 hoofdletter
        </li>
        <li v-bind:class="{ is_valid: passwordValidation.contains_special_character, pass_check: true }">
          Bevat minimaal 1 leesteken
        </li>
        <li v-bind:class="{ is_valid: passwordValidation.password_match, pass_check: true }">
          Beide wachtwoorden moeten overeen komen
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { checkPassword } from '@/_helpers'

export default {
  props: {
    password: {
      type: String,
      default: '',
    },
    passwordConfirmation: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {
      passwordValidation: []
    }
  },
  watch: {
    password: function (val) {
      this.updateValidationChecks()
    },

    passwordConfirmation: function (val) {
      this.updateValidationChecks()
    }
  },
  methods: {
    updateValidationChecks () {
      this.passwordValidation = checkPassword(this.password, this.passwordConfirmation)
    },
  },

}
</script>

<style scoped>
ul.pass_list {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.pass_check {
  margin-bottom: 8px;
  position: relative;
}

.pass_check:before {
  content: "";
  width: 0%;
  height: 2px;
  background: #2ecc71;
  position: absolute;
  left: 0;
  top: 50%;
  display: block;
  transition: all .6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.is_valid {
  color: rgba(136, 152, 170, 0.8);
}

.is_valid:before {
  width: 100%;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}

.password-validations {
  margin-top: 10px;
}
@media (min-width: 577px) {

  .password-validations:before {
    position: absolute;
    top: CALC(50% - 10px);
    left: -25px;
    font-size: 40px;
  }

  .password-validations {
    width: 400px;
    height: 230px;
    position: absolute;
    z-index: 999;
    right: -400px;
    top: 100px;
    -webkit-box-shadow: 5px 5px 5px 0px rgba(0, 158, 15, 0.5);
    -moz-box-shadow: 5px 5px 5px 0px rgba(0, 158, 15, 0.5);
    box-shadow: 5px 5px 5px 0px rgba(0, 158, 15, 0.5);
  }
}
</style>